const messages = {
    cannotReassignUnassignedLead: 'Lead must be assigned before it can be reassigned',
    documentsTypes: 'Documents Types',
    documentType: 'Document Type',
    consents: 'Consents',
    completed: 'Completed',
    markCompleted: 'Mark completed',
    consentMarkedCompleted: 'Consent marked as completed',
    consentMarkedPending: 'Consent marked as pending',
    isRequired: 'Is Required',
    signatureRequired: 'Signature Required',
    generalAnesthesia: 'General Anesthesia',
    documentLanguage: 'Document Language',
    addDocumentType: 'Add Document Type',
    editDocumentType: 'Editar Tipo de Documento',
    addConsent: 'Add Consent',
    editConsent: 'Edit Consent',
    addPaymentMethod: 'Add Payment Method',
    editPaymentMethod: 'Edit Payment Method',
    height: 'Height',
    weight: 'Weight',
    drugs: 'Drugs',
    alcohol: 'Alcohol',
    nicotine: 'Nicotine',
    medicalAilments: 'Medical Ailments',
    medicines: 'Medicines',
    otherMedicalConditions: 'Other Medical Conditions',
    addYourComment: 'Add Your Comment',
    viewMore: 'View More',
    addedAComment: 'Added a comment',
    addedTags: 'added tags',
    viewDetailsFor: 'View Details For',
    medicalRecord: 'Medical Record',
    surgicalHistory: 'Surgical History',
    imageType: 'Image Type',
    before: 'Before',
    after: 'After',
    consentEditedSuccesfully: 'Consent edited successfully',
    editProfile: 'Edit Profile',
    size: 'Size',
    pountAbbreviation: 'Lbs',
    bmi: 'BMI',
    sendForSignature: 'Send for signature',
    signNowInviteSelectConsents: 'Select existing consents to send for signature.',
    signNowInviteSent: 'SignNow invite sent',
    signNowNotLinked: 'SignNow not linked',
    signNowInviteConfirmTitle: 'Confirm lead email',
    signNowInviteConfirmText:
        'Please confirm the lead email looks correct before sending the SignNow invite: {email}',
    signNowInviteConfirmAction: 'Send invite',
    signNowInviteConfirmDescription:
        'Confirm the lead email before sending the SignNow invite: {email}',
    signNowInviteEmailLabel: 'Lead email',
    signNowInviteEmailRequired: 'Lead email is required.',
    signNowInviteEmailInvalid: 'Enter a valid email address.',
    signNowInviteEmailHint: 'Edits will update the lead before the SignNow invite is sent.',
    leadEmailUnknown: 'Unknown email',
    noSignNowTemplatesAvailable:
        'No SignNow-linked consents are available yet. Link a template to send for signature.',
    signNowTemplatesOnly: 'Only consents linked to SignNow can be sent for signature.',
    deprecadedHeight:
        'Deprecaded Height: Retained for reference purposes only, to configure the new height field.',
    newFeaturesWarning:
        "We've made important improvements. Refresh to get the latest features and fixes.",
    printConsents: 'Print consents',
    printConsentsSelectDocuments:
        'Select completed consent documents to download as a combined PDF.',
    noPrintableConsentDocuments: 'No completed consent documents are available to print.',
    printConsentsPdfReady: 'Combined PDF downloaded successfully.',
    printConsentsPdfError: 'Failed to generate consent PDF. Please try again.',
    category: 'Category',
    categories: 'Categories',
    none: 'None',
    consentTemplateCategories: 'Manage consent template categories.',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    confirmDeleteCategory: 'Confirm category deletion',
    deleteCategory: 'Are you sure you want to delete this category?',
    signNowStatus: 'SignNow Status',
    uncategorized: 'Uncategorized',
    signNowRoleAssignmentTitle: 'Assign signers',
    signNowRoleAssignmentDescription:
        'Assign an email address to each signer role. Required roles must have a valid email.',
    signNowRolePatientBadge: 'Patient',
    signNowRoleSigningOrder: 'Order: {order}',
    signNowRoleEmailPlaceholder: "signer{'@'}example.com",
    signNowRoleEmailRequired: 'Email is required for this role.',
    signNowFetchingRoles: 'Loading signer roles...',
    signNowRoleFetchError: 'Failed to load signer roles. Please try again.',
    signNowRoleAssignmentUnavailable:
        'Signer roles are unavailable for the selected documents. Close this step and try again.',
    signNowRoleDuplicateEmailWarning:
        'Some signer roles share the same email address. SignNow will send one invite per step to that shared inbox.',
    required: 'Required',
    optional: 'Optional',
    requireDescriptionForAdditionalDocuments: 'Require Description for Additional Documents',
    envelopeTrackingTitle: 'Envelope Tracking',
    envelopeTrackingDescription: 'Review sent envelopes, consent coverage, and completion status.',
};

export default messages;
